export const renderConfigs = {
    modal: {
        render: {
            component: 'cart-rules-confirm-modal',
        },
        container: {
            className: 'addiesaas-cart-rules-confirm-container addiesaas-cart-rules-modal'
        }
    },
    bar: {
        render: {
            component: 'cart-rules-confirm-bar',
            options: {
                component: {
                    attributes: {
                        parentAttrs: {
                            block: true
                        }
                    }
                }
            }
        },
        container: {
            className: 'addiesaas-cart-rules-confirm-container addiesaas-cart-rules-confirm-bar',
            style: {
                position: 'absolute',
                top: 0,
                zIndex: 2147483647,
                width: '100%'
            }
        }
    },
    placeholder: {
        render: {
            component: 'cart-rules-confirm-bar',
        },
        container: {
            className: 'addiesaas-cart-rules-confirm-container addiesaas-cart-rules-placeholder'
        }
    }
}
